module.exports = __webpack_public_path__ + "static/media/Guitar-8.79b97edd.jpg";